import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import './AdminLogin.css';

function AdminLogin() {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [loginError, setLoginError] = useState('');
  const navigate = useNavigate();

  // Fixed admin credentials
  const ADMIN_EMAIL = 'admin@manawave.com';
  const ADMIN_PASSWORD = 'admin123';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear errors when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
    if (loginError) {
      setLoginError('');
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoginError('');
    
    if (validateForm()) {
      // Check admin credentials
      if (formData.email === ADMIN_EMAIL && formData.password === ADMIN_PASSWORD) {
        // Successful login
        console.log('Admin login successful');
        // Store admin session (you can use localStorage or context)
        localStorage.setItem('adminLoggedIn', 'true');
        localStorage.setItem('adminEmail', ADMIN_EMAIL);
        // Navigate to admin dashboard
        navigate('/admin-dashboard');
      } else {
        setLoginError('Invalid email or password. Please try again.');
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        {/* Admin Login Form */}
        <div className="auth-form-wrapper">
          <h2 className="auth-title">Admin Login</h2>
          <p className="auth-subtitle">Access the admin dashboard</p>

          {loginError && (
            <div className="login-error-message" style={{
              backgroundColor: 'rgba(236, 72, 153, 0.1)',
              border: '1px solid rgba(236, 72, 153, 0.3)',
              borderRadius: '12px',
              padding: '1rem',
              marginBottom: '1.5rem',
              color: '#EC4899',
              fontSize: '0.9rem',
              textAlign: 'center'
            }}>
              {loginError}
            </div>
          )}

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Admin Email"
                value={formData.email}
                onChange={handleChange}
                className={`form-input ${errors.email ? 'error' : ''}`}
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>

            <div className="form-group">
              <input
                type="password"
                name="password"
                id="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                className={`form-input ${errors.password ? 'error' : ''}`}
              />
              {errors.password && <span className="error-message">{errors.password}</span>}
            </div>

            <button type="submit" className="auth-button">
              Login as Admin
            </button>
          </form>
        </div>

        {/* Privacy Note */}
        <div className="auth-footer">
          <p className="privacy-note">
            Admin access only. Unauthorized access is prohibited.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;

